import { authFetch } from "~/services/fetch";

export async function getById(model: string, id: string | number | undefined | null) {
    const response = await authFetch({
        url: `/${model}/${id}`,
        method: 'GET'
    });
    return response.data;
}